// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format9 } from '../../constants';

import { format13 } from '../../constants';

/** Laos */
const LA: PhoneNumberData = [856, 'LA', 9, format9, 10, format13];

export default LA;
